import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const currentIndex = createReducer(-1, {
  [Constants.workDetails.show]: (_, { index }) => index,
  [Constants.workDetails.hide]: () => (-1)
});

export default currentIndex;
